import { PersistenceRegistry } from '../base/redux';
import ReducerRegistry from '../base/redux/ReducerRegistry';

import {
  OPEN_GROUPS,
  OPEN_SETTINGS,
  SET_AUDIO_SETTINGS_VISIBILITY,
  SET_SETTINGS,
  SET_VIDEO_ONLY,
  SET_VIDEO_SETTINGS_VISIBILITY
} from './actionTypes';

// export interface ISettingState {
//     audioSettingsVisible?: boolean;
//     videoSettingsVisible?: boolean;
//     userSleepMode?: boolean;
//     userPrivacyMode?: boolean;
//     userExternalMode?: boolean;
//     sleepHours?: number;
//     sleepMinutes?: number;
//     videoOnly: boolean;
// }
const DEFAULT_STATE = {
  videoOnly: true,
  videoState: false,
  userSleepMode: false,
  userPrivacyMode: false,
  userExternalMode: false,
  userBrowserMode: false,
  browserOptions: null,
  conferenceSetting: false,
  conferenceGroups: false,
  userDigitalSignageMode: false,
  digitalSignageOptions: null,
  userIdleMode: false,
  sleepHours: 0,
  sleepMinutes: 0
};
const filterSubtree = {};

// start with the default state
Object.keys(DEFAULT_STATE).forEach((key) => {
  const key1 = key;
  filterSubtree[key1] = true;
});
PersistenceRegistry.register('features/settings', filterSubtree, DEFAULT_STATE);

ReducerRegistry.register(
  'features/settings',
  (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      case SET_AUDIO_SETTINGS_VISIBILITY:
        return {
          ...state,
          audioSettingsVisible: action.value
        };
      case SET_VIDEO_SETTINGS_VISIBILITY:
        return {
          ...state,
          videoSettingsVisible: action.value
        };
      case SET_SETTINGS:
        return {
          ...state,
          ...action.data
        };
      case OPEN_SETTINGS:
        return {
          ...state,
          conferenceSetting: action.data
        };
      case OPEN_GROUPS:
        return {
          ...state,
          conferenceGroups: action.data
        };
      case SET_VIDEO_ONLY:
        return {
          ...state,
          videoOnly: action.value
        };
    }
    return state;
  }
);
